import { CheckCircle, Warning, Error, TrendingUp, Pending } from "@mui/icons-material"
import { AuditLotStatus } from "src/graphql/quark/quark.type"

export const getLotStatusIcon = (status: AuditLotStatus) => {
  switch (status) {
    case AuditLotStatus.Matched:
      return <CheckCircle color="success" fontSize="small" />
    case AuditLotStatus.Short:
      return <Warning color="warning" fontSize="small" />
    case AuditLotStatus.Excess:
      return <TrendingUp color="info" fontSize="small" />
    case AuditLotStatus.Discrepancy:
      return <Error color="error" fontSize="small" />
    case AuditLotStatus.Verified:
      return <CheckCircle color="success" fontSize="small" />
    case AuditLotStatus.Counted:
      return <CheckCircle color="primary" fontSize="small" />
    case AuditLotStatus.InAudit:
      return <Pending color="warning" fontSize="small" />
    case AuditLotStatus.Pending:
      return <Pending color="action" fontSize="small" />
    default:
      return <Pending color="action" fontSize="small" />
  }
}

export const getLotStatusColor = (status: AuditLotStatus) => {
  switch (status) {
    case AuditLotStatus.Matched:
    case AuditLotStatus.Verified:
      return "success"
    case AuditLotStatus.Short:
    case AuditLotStatus.InAudit:
      return "warning"
    case AuditLotStatus.Excess:
      return "info"
    case AuditLotStatus.Discrepancy:
      return "error"
    case AuditLotStatus.Counted:
      return "primary"
    case AuditLotStatus.Pending:
    default:
      return "default"
  }
}

export const getLotStatusLabel = (status: AuditLotStatus) => {
  switch (status) {
    case AuditLotStatus.Matched:
      return "Matched"
    case AuditLotStatus.Short:
      return "Short"
    case AuditLotStatus.Excess:
      return "Excess"
    case AuditLotStatus.Discrepancy:
      return "Discrepancy"
    case AuditLotStatus.Verified:
      return "Verified"
    case AuditLotStatus.Counted:
      return "Counted"
    case AuditLotStatus.InAudit:
      return "In Audit"
    case AuditLotStatus.Pending:
      return "Pending"
    default:
      return "Unknown"
  }
}
